<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog"
        title="评价"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="WorkOrderEvaluateForm"
                :model="WorkOrderEvaluateForm"
                :rules="WorkOrderEvaluateFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="评价人" prop="processing_users">
                    <el-select
                        placeholder="请选择"
                        multiple
                        filterable
                        collapse-tags
                        v-model="WorkOrderEvaluateForm.processing_users"
                    >
                        <el-option
                            :key="user.id"
                            :label="user.disabled ? user.name + '（已评价）' : user.name"
                            :value="user.id"
                            :disabled="user.disabled"
                            v-for="user in processingUserList"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评价分数" prop="star">
                    <el-input
                        type="number"
                        :step="0.01"
                        class="pay_amount_input"
                        size="small"
                        v-model="WorkOrderEvaluateForm.star"
                        @input="handleInput"
                        @blur="formatValue"
                        placeholder="请输入"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="评价内容" prop="content">
                    <el-input
                        v-model="WorkOrderEvaluateForm.content"
                        :rows="7"
                        maxlength="500"
                        placeholder="请输入"
                        show-word-limit
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { workOrderEvaluateDetail, workOrderEvaluate } from "@/api";
export default {
    name: "WorkOrderEvaluate",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        workorder_num: {
            type: String,
            default: "",
        },
        // 实施人员
        processing_users_selected: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            loading: false,
            WorkOrderEvaluateForm: {
                processing_users: "",
                star: "",
                content: "",
            },
            WorkOrderEvaluateFormRules: {
                processing_users: [{ required: true, message: "请选择", trigger: ["change"] }],
                star: [{ required: true, message: "请输入", trigger: ["blur", "change"] }],
            },
            previousValue: null, // 用于缓存合法值

            processingUserList: [], // 可以选择的
            processingUserSelectedList: [], // 已经选择过的
        };
    },
    created() {
        this.processingUserSelectedList = this.processing_users_selected.map((item) => {
            return item.processing_user;
        });
        if (this.workorder_id) {
            this.getWorkOrderEvaluateDetail();
        }
        this.$nextTick(() => {
            this.$refs.WorkOrderEvaluateForm.clearValidate();
        });
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        getWorkOrderEvaluateDetail() {
            workOrderEvaluateDetail({ workorder_id: this.workorder_id }).then((res) => {
                if (res.code === 200) {
                    const ids = res.data || [];
                    const processingUserList = this.processingUserSelectedList.map((item) => {
                        return {
                            ...item,
                            disabled: ids.includes(item.id),
                        };
                    });
                    this.processingUserList = processingUserList;
                }
            });
        },
        handleInput(value) {
            if (value === null || value === "") {
                this.previousValue = value;
                return;
            }

            // 正则匹配：整数部分可空，小数部分最多两位
            const regex = /^-?\d*\.?\d{0,2}$/;
            if (regex.test(value)) {
                this.previousValue = value; // 缓存合法值
            } else {
                // 非法输入时，回退到上一次合法值
                this.WorkOrderEvaluateForm.star = this.previousValue;
            }
        },
        formatValue() {
            if (this.WorkOrderEvaluateForm.star === null || this.WorkOrderEvaluateForm.star === "") return;

            // 处理前导小数点（如 ".5" -> "0.5"）
            let value = String(this.WorkOrderEvaluateForm.star);
            if (value.startsWith(".")) value = "0" + value;

            // 转换为数值并保留两位小数
            const num = parseFloat(value);
            this.WorkOrderEvaluateForm.star = isNaN(num) ? null : Number(num.toFixed(2));
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.WorkOrderEvaluateForm.validate((valid) => {
                if (valid) {
                    const processing_users = this.processingUserList
                        .filter((item) => this.WorkOrderEvaluateForm.processing_users.includes(item.id))
                        .map((item) => ({ processing_uid: item.id, processing_name: item.name }));
                    const params = {
                        workorder_id: this.workorder_id,
                        workorder_num: this.workorder_num,
                        processing_users,
                        star: this.WorkOrderEvaluateForm.star,
                        content: this.WorkOrderEvaluateForm.content,
                    };
                    workOrderEvaluate(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
